import React from 'react';
function SectionName({ title, sub_title, description }) {

    return (
        <>
            <div className='section_title' data-aos="fade-right" data-aos-duration="3000" data-aos-easing="linear">
                <h5>{sub_title}</h5>
                <h1>{title}</h1>
                <p>{description}</p>
            </div>
        </>
    )
}

export default SectionName